<template>
  <div>
    <insuranceDetail />
  </div>
</template>

<script>
import insuranceDetail from "./insuranceDetail";

export default {
  components: {
    insuranceDetail,
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>
<style lang="less">
.el-scrollbar {
  max-width: 350px !important;
}
.inputDeep {
  .el-input__inner {
    border: 1px solid red !important; //边框颜色
  }
}
.treeDeep {
  .vue-treeselect__control {
    border: 1px solid red !important; //边框颜色
  }
}
</style>
<style lang="less" scoped>
</style>